import { render, staticRenderFns } from "./YesNoModal.vue?vue&type=template&id=13b0e546&scoped=true&"
import script from "./YesNoModal.vue?vue&type=script&lang=js&"
export * from "./YesNoModal.vue?vue&type=script&lang=js&"
import style0 from "./YesNoModal.vue?vue&type=style&index=0&id=13b0e546&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b0e546",
  null
  
)

export default component.exports